// extracted by mini-css-extract-plugin
module.exports = {"posts":"blog-module--posts--23e4V","tags":"blog-module--tags--xN5v7"};